var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatFiveStar = function SvgStatFiveStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.158 3.364 1.687 3.373c.23.47.843.92 1.36 1.006l3.058.508c1.954.326 2.414 1.744 1.006 3.144l-2.377 2.376c-.402.403-.623 1.179-.498 1.735l.68 2.942c.537 2.329-.7 3.23-2.76 2.012l-2.865-1.696c-.518-.306-1.37-.306-1.898 0L7.686 20.46c-2.051 1.217-3.297.307-2.76-2.012l.68-2.942c.125-.556-.096-1.332-.498-1.735l-2.377-2.376c-1.399-1.4-.948-2.818 1.007-3.144l3.057-.508c.508-.086 1.12-.536 1.35-1.006l1.688-3.373c.92-1.83 2.415-1.83 3.325 0Z"
  })));
};
export default SvgStatFiveStar;